<template>

  <div class="base">
  
    <!-- <div class="pesquisa"> -->
        <!-- <h2>Maquinas</h2> -->
    <!-- <label> Procurar por:</label><input class="form-control" v-model="searchTerm" /> -->
    <!-- </div> -->

   <TableLite
   :is-static-mode="true"
    :columns="columns"
    :rows="rows"
    :total="totalRecordCount"
    :sortable="sortable"
   />

  </div>
</template>

<script>
import TableLite from '../../../components/Tables/Table-Simple.vue'
import {GetDataAllMaquinas } from "../../../controllers/Maquinas/GetDataAllMaquinas"
export default {
components : { TableLite },
async created(){
  const res = await GetDataAllMaquinas();
  if(res){
    this.data = res.data.list
  }

},
data(){
  return {
   isLoading : false,
   searchTerm : "",
   columns : [
     
     {
       label : "Maquina",
       field : "nome",
       width : "8%",
       sortable : true
     },
     {
     label : "Tonelagem",
     field : "tonelagem",
     width : "12%",
     sortable : true,
     isKey : true,
     },
     {
       label : "Quantidade",
       field : "quantidade",
       width : "8%",
       sortable : true,
     },
     {
       label : "D/ Colunas por comprimento",
       field : "distancia_colunas_comp",
       width : "12%",
       sortable : true,
     },{
       label : "D/ Colunas por largura",
       field : "distancia_colunas_larg",
       width : "15%",
       sortable : true,
    },
    {
       label : "Altura Mínoma",
       field : "altura_molde_min",
       width : "15%",
       sortable : true,
    },{
       label : "Altura Maxima",
       field : "altura_molde_max",
       width : "15%",
       sortable : true,
    }
    ,{
       label : "Peso da Injeção",
       field : "peso_injecao",
       width : "15%",
       sortable : true,
    },{
       label : "Cliente",
       field : "fabricante",
       width : "15%",
       sortable : true,
    },{
       label : "Modelo",
       field : "modelo",
       width : "15%",
       sortable : true,
    }
   ],

   data : [],

   sortable : {
     order : "id",
     sort : "asc"
   },
   }
   },
   computed : {

     totalRecordCount(){

       return this.rows.length;
     },

      rows() {
        return this.data.filter( (x) =>
            x.nome.includes(this.searchTerm)
        );
      }
      

   }

}
</script>

<style scoped>

.table td,
.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid var(--cinza);
}

.form-control{
    display: block;
    width: 240px;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: var(--inputColor);
    background-color: var(--white);
    background-clip: padding-box;
    border: 1px solid var(--greyBtn);
    border-radius: 0.35rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.base{
    padding: 15px;
    /* background: #fff; */
    border-radius: 15px;
}

.pesquisa{
  
    /* text-align: left; */
    display: flex;
    justify-content: end;
    align-items: center;
}





</style>
